import React from "react";
import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { NewsletterForm } from "./NewsletterForm";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-[#1a1814] text-[#f0e9e1] mt-32" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-14 sm:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
        <div className="lg:col-span-5">
          <div className="micro-label text-[#f0e9e1]/60 mb-6">Join the Atelier</div>
          <h3 className="font-display text-3xl sm:text-4xl text-[#f0e9e1] mb-8 leading-tight max-w-md">
            A quiet correspondence. New arrivals, fittings and field notes for the tall.
          </h3>
          <NewsletterForm variant="dark" />

          <a
            href="https://www.instagram.com/the_identityatelier/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-8 micro-label text-[#f0e9e1] hover:opacity-70 transition-opacity"
            data-testid="footer-instagram-link"
            aria-label="Follow The Identity Atelier on Instagram"
          >
            <Instagram className="w-4 h-4" strokeWidth={1.25} />
            <span>@the_identityatelier</span>
          </a>
        </div>

        <div className="lg:col-span-2">
          <div className="micro-label text-[#f0e9e1]/60 mb-4">Shop</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop?category=lounge" className="hover:opacity-70" data-testid="footer-shop-lounge">Lounge</Link></li>
            <li><Link to="/shop?category=active" className="hover:opacity-70" data-testid="footer-shop-active">Active</Link></li>
            <li><Link to="/shop" className="hover:opacity-70" data-testid="footer-shop-all">All Pieces</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="micro-label text-[#f0e9e1]/60 mb-4">House</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:opacity-70" data-testid="footer-about">Our Story</Link></li>
            <li><a href="#" className="hover:opacity-70">Sizing</a></li>
            <li><a href="#" className="hover:opacity-70">Fabric</a></li>
            <li><a href="#" className="hover:opacity-70">Care</a></li>
          </ul>
        </div>

        <div className="lg:col-span-3 flex flex-col items-start lg:items-end justify-between gap-8">
          <Logo size="md" />
          <div className="text-xs text-[#f0e9e1]/50">
            © {new Date().getFullYear()} The Identity Atelier. Made for height.
          </div>
        </div>
      </div>
    </footer>
  );
};
